export default __webpack_public_path__ + "static/media/addp.d122a795.wav";